import styled from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 2rem;
`

export const Card = styled.div`
    background: ${colors.primaryWhite};
    border-radius: 16px;
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 3rem 2.5rem;
    text-align: center;
    max-width: 500px;
    width: 100%;
`

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;

    svg {
        color: ${colors.lobster60};
    }
`

export const Content = styled.div`
    margin-bottom: 2rem;
`

export const Title = styled.h2`
    ${getFontStyle('h2Bold')}
    color: ${colors.primary90};
    margin: 0 0 0.75rem 0;
`

export const Message = styled.p`
    ${getFontStyle('p01Regular')}
    color: ${colors.primary65};
    margin: 0;
    line-height: 1.5;
`

export const Actions = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;
`
